const AMADEUS_MONTHS = [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec',
];
/**
 * Format a date to Amadeus ddMMMyy format (e.g. "16jan73").
 * Returns empty string if date is null/undefined.
 */
export function formatAmadeusDate(date) {
    if (!date)
        return '';
    const d = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(d.getTime()))
        return '';
    const day = String(d.getDate()).padStart(2, '0');
    const month = AMADEUS_MONTHS[d.getMonth()];
    const year = String(d.getFullYear()).slice(-2);
    return `${day}${month}${year}`;
}
/**
 * Generate an Amadeus-formatted document string:
 * type-issuingCountry-docNumber-nationality-birthDate-gender-expiryDate-lastName-firstName
 *
 * Example: "p-fra-19de42950-fra-16jan73-f-15may29-raimbaud-christelle"
 * All lowercase.
 */
export function formatAmadeusDocument(input) {
    const type = input.type === 'PASSPORT' ? 'p' : 'i';
    const issuingCountry = (input.issuingCountry ?? '').toLowerCase();
    const docNumber = (input.documentNumber ?? '').toLowerCase();
    const nationality = (input.nationalityCode ?? '').toLowerCase();
    const birthDate = formatAmadeusDate(input.birthDate);
    const gender = input.gender === 'FEMALE' ? 'f' : 'm';
    const expiryDate = formatAmadeusDate(input.expiryDate);
    const lastName = input.lastName.toLowerCase();
    const firstName = input.firstName.toLowerCase();
    return `${type}-${issuingCountry}-${docNumber}-${nationality}-${birthDate}-${gender}-${expiryDate}-${lastName}-${firstName}`;
}
